var _style, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoWpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 294.05 294.05",
    style: {
      enableBackground: "new 0 0 294.05 294.05"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC303;}\n\t.st1{fill:#1A1A1A;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 147.02,
    cy: 147.02,
    r: 147.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.18,153.28c-0.4-0.19-15.4-7.57-18.06-8.53c-1.11-0.46-2.3-0.72-3.5-0.78c-2.07,0.07-3.96,1.2-5,3 c-1.5,2.22-6,7.52-7.43,9.11c-0.19,0.21-0.44,0.46-0.59,0.46s-2.45-1-3.15-1.26c-16.09-7-28.31-23.8-30-26.63 c-0.12-0.18-0.21-0.38-0.25-0.6c0.25-0.37,0.54-0.71,0.88-1c0.81-0.81,1.7-1.88,2.56-2.91c0.4-0.49,0.81-1,1.21-1.44 c0.99-1.16,1.81-2.46,2.43-3.86l0.34-0.68c1.03-2.09,0.95-4.56-0.21-6.58c-0.35-0.71-6.68-16-7.36-17.6 c-1.62-3.88-3.76-5.68-6.73-5.68c-0.27,0,0,0-1.16,0c-1.4,0.06-9.08,1.07-12.47,3.2c-3.67,2.29-9.67,9.52-9.67,22.23 c0,11.45,7.26,22.25,10.38,26.36c0.08,0.1,0.22,0.31,0.42,0.61c11.94,17.44,26.83,30.36,41.91,36.39 c14.53,5.8,21.41,6.47,25.32,6.47l0,0c1.38-0.01,2.75-0.09,4.12-0.24l0.73-0.07c5-0.45,16-6.16,18.56-13.13 c2-5.49,2.49-11.49,1.18-13.67C202.7,155.02,201.15,154.23,199.18,153.28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.64,35.02c-55.72,0-101.05,45-101.05,100.34c-0.01,17.84,4.78,35.36,13.85,50.72l-17.35,51.19 c-0.47,1.4,0.27,2.91,1.67,3.39c0.28,0.09,0.57,0.14,0.86,0.14c0.27,0,0.55-0.04,0.81-0.12l53.38-17 c14.72,7.84,31.15,11.94,47.83,11.93c55.72,0,101-45,101-100.28S207.36,35.02,151.64,35.02z M151.64,214.71 c-15.63,0.02-30.93-4.55-44-13.13c-0.44-0.29-0.95-0.44-1.47-0.44c-0.27,0-0.55,0.04-0.81,0.12l-26.74,8.51l8.63-25.47 c0.28-0.83,0.14-1.73-0.37-2.44c-9.92-13.49-15.27-29.8-15.24-46.54c0-43.79,35.91-79.4,80-79.4s80,35.61,80,79.4 s-35.87,79.43-80,79.43V214.71z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoWpp);
export default __webpack_public_path__ + "static/media/iconoWPP.b4795701bc0a26849279713829c58a85.svg";
export { ForwardRef as ReactComponent };